import { MetadataModel } from '@thehubz/client/core';
import { AssetMetadata } from '@thehubz/shared/model';

export const VorwerkMandatoryField: MetadataModel[] = [
  {
    formControlName: '_id',
    formFieldName: $localize`Asset Id`,
    selected: true,
  },
  {
    formControlName: 'name',
    formFieldName: $localize`Name`,
    selected: true,
  },
  {
    formControlName: 'status',
    formFieldName: $localize`Status`,
    selected: true,
  },
  {
    formControlName: 'assetType',
    formFieldName: $localize`Asset type`,
    selected: true,
  },
  {
    formControlName: 'domains',
    formFieldName: $localize`Domains`,
    selected: true,
  },
  {
    formControlName: 'createdAt',
    formFieldName: $localize`Created at`,
    selected: true,
  },
  {
    formControlName: 'createdBy',
    formFieldName: $localize`Created by`,
    selected: true,
  },
  {
    formControlName: AssetMetadata.General.TAGS,
    formFieldName: $localize`Tags`,
    selected: true,
  },
  {
    formControlName: 'customFields',
    formFieldName: $localize`Custom fields`,
    selected: true,
    hideField: true,
  },
];

export const VorwerkNonMandatoryField: MetadataModel[] = [
  {
    formControlName: 'subject',
    formFieldName: $localize`Subject`,
    customField: true,
  },
  {
    formControlName: 'channel',
    formFieldName: $localize`Channel`,
    customField: true,
  },
  {
    formControlName: 'exchange_link',
    formFieldName: $localize`Exchange link`,
    customField: true,
  },
  {
    formControlName: 'description',
    formFieldName: $localize`Description`,
  },
  {
    formControlName: 'relations',
    formFieldName: $localize`Relations`,
    customField: true,
  },
  {
    formControlName: 'usageRights',
    formFieldName: $localize`Usage rights`,
    formFieldGroup: [
      { formControlName: 'compositionmusic', formFieldName: 'Composition music' },
      { formControlName: 'image', formFieldName: 'Image' },
      { formControlName: 'stockmaterial', formFieldName: 'Stock material' },
      { formControlName: 'video', formFieldName: 'Video' },
      { formControlName: 'voiceover', formFieldName: 'Voice-over' },
      { formControlName: 'notes', formFieldName: $localize`Notes` },
    ],
  },
];
